export const AdditionalCreditRoles = [
  "None",
  "Camera Operator",
  "Cinemaphotographer",
  "Costume Design",
  "Director",
  "Editor",
  "Gaffer",
  "Key Grip",
  "Lighting Director",
  "Motion Designer",
  "Set Designer",
  "Video Producer",
  "Visual Effects"
];
